import { AnalyzeRasComponent } from '../components/ras/analyze-ras/analyze-ras.component';
import { DescriptionRasComponent } from '../components/ras/description-ras/description-ras.component';
import { OperationsAndInstrumentsRelatedToRASComponent } from '../components/ras/operations-and-instruments-related-to-ras/operations-and-instruments-related-to-ras.component';
import { PeopleRelatedToTheRASComponent } from '../components/ras/people-related-to-the-ras/people-related-to-the-ras.component';
import { PersonInvolvedRasComponent } from '../components/ras/person-involved-ras/person-involved-ras.component';
import { RegisterHypothesisRasComponent } from '../components/ras/register-hypothesis-ras/register-hypothesis-ras.component';
import { SucursalRasComponent } from '../components/ras/sucursal-ras/sucursal-ras.component';

export const COMPONENTS = [
  {
    name: 'Analizar RAS',
    value: 'analyzeRas',
    component: AnalyzeRasComponent,
    caso: 'Análisis de RAS',
  },
  {
    name: 'Persona Implicada en la actividad sospechosa.',
    value: 'personInvolvedRas',
    component: PersonInvolvedRasComponent,
    caso: 'Análisis de RAS',
  },
  {
    name: 'Descripción del RAS.',
    value: 'descriptionRas',
    component: DescriptionRasComponent,
    caso: 'Análisis de RAS',
  },
  {
    name: 'Sucursal',
    value: 'sucursalRas',
    component: SucursalRasComponent,
    caso: 'Análisis de RAS',
  },
  {
    name: 'Operaciones e instrumentos relacionados con RAS',
    value: 'operationsAndInstrumentsRelatedToRAS',
    component: OperationsAndInstrumentsRelatedToRASComponent,
    caso: 'Análisis de RAS',
  },
  {
    name: 'Personas relacionadas con el RAS',
    value: 'peopleRelatedToTheRAS',
    component: PeopleRelatedToTheRASComponent,
    caso: 'Análisis de RAS',
  },
  {
    name: 'Registrar Hipotesis Ras ',
    value: 'RegisterHypothesisRas',
    component: RegisterHypothesisRasComponent,
    caso: 'Análisis de RAS',
  },
];
